import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Paper,
    Typography,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
} from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { useLang } from "../../context/LanguageContext";

const BuyInvoices = () => {
    const [invoices, setInvoices] = useState([]);
    const authHeader = useAuthHeader();
    const navigate = useNavigate();
    const { t } = useLang();

    useEffect(() => {
        const fetchBuyInvoices = async () => {
            const resp = await fetch(
                `${REACT_APP_BACKEND_URL}/invoices/buyInvoices`,
                {
                    method: "GET",
                    headers: {
                        Authorization: authHeader,
                        "Content-Type": "application/json",
                    },
                },
            );
            const result = await resp.json();
            setInvoices(result.buyInvoices);
        };
        fetchBuyInvoices();
    }, []);

    const handleViewClick = (id) => {
        navigate(`/BuyInvoices/${id}`);
    };

    return (
        <Box sx={{ width: "100%" }}>
            {/* Modern Page Header */}
            <Paper
                elevation={0}
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                    p: 2.5,
                    borderRadius: 3,
                    background:
                        "linear-gradient(135deg, #5c6bc0 0%, #283593 100%)",
                    color: "white",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <ReceiptLongIcon sx={{ fontSize: 32, opacity: 0.9 }} />
                    <Box>
                        <Typography variant="h5" fontWeight={700}>
                            {t("PURCHASES")}
                        </Typography>
                        <Chip
                            label={`${invoices.length} ${t("PURCHASES")}`}
                            size="small"
                            sx={{
                                bgcolor: "rgba(255,255,255,0.2)",
                                color: "white",
                                fontWeight: 600,
                                mt: 0.5,
                            }}
                        />
                    </Box>
                </Box>
            </Paper>

            {/* Table */}
            <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ bgcolor: "grey.50" }}>
                            <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>
                                {t("DATE")}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>
                                {t("TOTAL_PRICE")}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>
                                {t("EMPLOYEE")}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>
                                {t("OTHER_PARTIES")}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>
                                {t("ACTIONS")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoices.map((invoice) => (
                            <TableRow
                                key={invoice.id}
                                hover
                                sx={{ "&:last-child td": { border: 0 } }}
                            >
                                <TableCell>{invoice.id}</TableCell>
                                <TableCell>
                                    {new Date(
                                        invoice.createdAt,
                                    ).toLocaleString()}
                                </TableCell>
                                <TableCell>${invoice.totalPrice}</TableCell>
                                <TableCell>
                                    {invoice.employee.name} (
                                    {invoice.employee.username})
                                </TableCell>
                                <TableCell>
                                    {invoice.otherParty.name} (
                                    {invoice.otherParty.phone})
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        onClick={() =>
                                            handleViewClick(invoice.id)
                                        }
                                        color="primary"
                                    >
                                        <VisibilityIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BuyInvoices;
